var _defs, _rect, _circle, _circle2, _rect2, _rect3, _path, _path2, _path3, _path4, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanner3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#e5f7f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d7f1eb"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 160,
    r: 110,
    fill: "#f59e0b",
    opacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 740,
    cy: 120,
    r: 90,
    fill: "#0f766e",
    opacity: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 210,
    width: 320,
    height: 320,
    rx: 26,
    fill: "#ffffff",
    opacity: 0.88
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 240,
    width: 310,
    height: 280,
    rx: 28,
    fill: "#ffffff",
    opacity: 0.92
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 270h200",
    stroke: "#0f766e",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180 310h160",
    stroke: "#f59e0b",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M520 300h200",
    stroke: "#0f766e",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M520 340h170",
    stroke: "#f59e0b",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 440,
    r: 36,
    fill: "#0f766e",
    opacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 440,
    r: 36,
    fill: "#f59e0b",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner3);
export default __webpack_public_path__ + "static/media/banner-3.68ae61a101081d75a121e95bc210e637.svg";
export { ForwardRef as ReactComponent };